<template>
  <el-card
    class="detail"
    v-loading="!isLoadForm"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <div class="title">一级信息</div>
    <FormData ref="fistFormRef" isUpdateStatus />
    <div class="foot-btn-group">
      <el-button type="primary" @click="saveBtnClickHandler">保存 </el-button>
      <el-button type="primary" @click="submitBtnClickHandler('create')">提交</el-button>
      <el-button type="info" @click="backBtnClickHandler">返回</el-button>
    </div>
  </el-card>
</template>

<script>
  import FormData from './components/FormData';
  import storeMixin from './../../storeMixin.js';
  export default {
    mixins: [storeMixin],
    data() {
      return {
        isLoadForm: true,
      };
    },
    methods: {
      // 保存按钮
      saveBtnClickHandler() {
        this.$refs.fistFormRef.validate((formData) => {
          this._postData('save', 'ZT01', 1, formData, []);
        });
      },
      // 提交按钮
      submitBtnClickHandler(type) {
        let tableData = [];
        this.$refs.fistFormRef.validate((formData) => {
          this._postData(type, 'ZT02', 1, formData, tableData);
        });
      },
      // 返回
      backBtnClickHandler() {
        this.$router.go(-1);
      },
    },
    components: {
      FormData,
    },
  };
</script>

<style></style>
